<template>
  <div class="auth">
    <div class="banner"></div>
    <div class="help"></div>
    <div class="main">
      <div class="logo"></div>
      <div class="title">Welcome to BASEC.</div>

      <v-card flat="flat" class="card" :loading="loading">
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-text-field
              v-model="username"
              label="Username or Email"
              type="text"
              :rules="usernameRules"
              required
            ></v-text-field>
            <v-text-field
              v-model="password"
              label="Password"
              type="password"
              :rules="passwordRules"
              required
            ></v-text-field>
            <p class="error_msg">{{ errorMessage }}</p>
            <v-btn class="mt-4 btn-submit" color="#2bb9aa" @click="login">
              CONTINUE
              <font-awesome-icon class="ml-1" icon="chevron-right" />
            </v-btn>

            <div class="terms">
              By clicking continue you agree to accept the
              <a>Terms of Service</a> and <a>Privacy Policy</a>
            </div>

            <v-row justify="space-between" class="options">
              <v-checkbox
                v-model="stayLoggedIn"
                label="Stay logged in"
                color="#2bb9aa"
              ></v-checkbox>
              <a @click="forgotPassword" class="forgot-password"
                >Forgot password?</a
              >
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>

      <div class="lang">
        <lang-select></lang-select>
        <div class="label-register">
          No account? <a @click="register">Sign up here</a>
        </div>
      </div>

      <v-snackbar v-model="snackbar" color="#2bb9aa">
        <span style="color: white">{{ snackText }}</span>
        <v-btn color="#222222" text @click="snackbar = false">
          Close
        </v-btn>
      </v-snackbar>
    </div>
    <div class="grey-background"></div>
    <!-- <VueReCaptcha/> -->
  </div>
</template>

<script>
// import Vue from "vue"
// import { VueReCaptcha } from 'vue-recaptcha-v3'

// Vue.use(VueReCaptcha, {
//   siteKey: '6Ld90sMUAAAAAFEZnLGb2gy52gWRlGTQ2JXg600E',
//   loaderOptions: {
//     useRecaptchaNet: true
//   }
// })

export default {
  created() {
    if (this.$store.state.auth.snack_show != 0) {
      this.snackbar = true;
      this.snackText =
        this.$store.state.auth.snack_show == 1
          ? "You have registered successfully"
          : "You have reset password successfully";
      this.$store.state.auth.snack_show = 0;
    }
  },

  data: () => ({
    valid: false,
    usernameRules: [v => !!v || "Username is required"],
    passwordRules: [v => !!v || "Password is required"],

    loading: false,

    username: "",
    password: "",
    stayLoggedIn: false,

    snackbar: false,
    snackText: "",
    errorMessage: ""
  }),

  methods: {
    login() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.errorMessage = "";
      this.$store
        .dispatch("login", {
          username: this.username,
          password: this.password
        })
        .then(() => {
          this.loading = false;
          this.$router.push({ path: "/login-verify" });
        })
        .catch(error => {
          this.loading = false;

          this.username = "";
          this.password = "";
          this.errorMessage = error.response.data.detail;
        });
    },

    register() {
      this.$router.push({ path: "/register" });
    },

    forgotPassword() {
      this.$router.push({ path: "/password-reset-request" });
    }
  }
};
</script>
